module.exports = __webpack_public_path__ + "img/Reg-1-face2face.3f1a2938.svg";